import React, { useState, useEffect } from 'react';
import API from '../api';
import Navbar from '../components/Navbar'; 
import Footer from '../components/Footer'; 
import '../App.css';

// Leaflet Imports
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default Leaflet icon not appearing
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
let DefaultIcon = L.icon({
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

// Helper component to refocus map
function ChangeView({ center }) {
  const map = useMap();
  map.setView(center, 15);
  return null;
}

const UserDashboard = () => {
  const [formData, setFormData] = useState({
    problemType: 'Petrol', 
    vehicleType: '', 
    location: '', 
    phone: '',
    lat: 12.9716, 
    lng: 77.5946
  });

  const [isOther, setIsOther] = useState(false);
  const [otherProblem, setOtherProblem] = useState('');
  const [profileData, setProfileData] = useState({ name: '', phone: '' });
  const [history, setHistory] = useState([]); 
  const [selectedMechanic, setSelectedMechanic] = useState(null); 
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [showSOSModal, setShowSOSModal] = useState(false);
  
  const userData = localStorage.getItem('user');
  const user = userData ? JSON.parse(userData) : null;

  const fetchHistory = async () => {
    try {
      if (user) {
        const res = await API.get(`/requests/user-history/${user.id}`);
        setHistory(res.data);
      }
    } catch (err) { console.error("Error fetching history:", err); }
  };

  useEffect(() => {
    if (user) {
      setProfileData({ name: user.name, phone: user.phone || '' });
      setFormData(prev => ({ ...prev, phone: user.phone || '' }));
      fetchHistory();
    }
  }, []);

  const handleLocateMe = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }
    setLoadingLocation(true);
    navigator.geolocation.getCurrentPosition(async (position) => {
      const { latitude, longitude } = position.coords;
      try {
        const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`);
        const data = await res.json();
        setFormData({ ...formData, location: data.display_name, lat: latitude, lng: longitude });
      } catch (err) {
        setFormData({ ...formData, lat: latitude, lng: longitude });
      }
      setLoadingLocation(false);
    }, () => {
      alert("Unable to retrieve location.");
      setLoadingLocation(false);
    });
  };

  const handleProblemChange = (e) => {
    const value = e.target.value;
    if (value === 'Other') {
      setIsOther(true);
      setFormData({ ...formData, problemType: '' });
    } else {
      setIsOther(false);
      setFormData({ ...formData, problemType: value });
    }
  };

  const sendRequest = async (e) => {
    e.preventDefault();
    try {
      const finalData = { ...formData, problemType: isOther ? otherProblem : formData.problemType, userId: user.id };
      await API.post('/requests/create', finalData);
      alert("Help is on the way!");
      setFormData({ ...formData, problemType: 'Petrol', vehicleType: '', location: '' });
      setIsOther(false);
      setOtherProblem('');
      fetchHistory();
    } catch (err) { alert("Failed to send request."); }
  };

  const updateProfile = async (e) => {
    e.preventDefault();
    try {
      const res = await API.put(`/auth/update-profile/${user.id}`, profileData);
      localStorage.setItem('user', JSON.stringify({ ...user, ...res.data }));
      alert("Profile updated successfully!");
    } catch (err) { alert("Failed to update profile."); }
  };

  const cancelRequest = async (requestId) => {
    if (window.confirm("Are you sure you want to cancel?")) {
      try {
        await API.delete(`/requests/cancel/${requestId}`);
        fetchHistory();
      } catch (err) { alert("Failed to cancel."); }
    }
  };

  return (
    <>
      <Navbar />
      <div className="container">
        
        {/* PROFILE SECTION */}
        <div className="card" style={{ marginBottom: '30px', borderTop: '4px solid var(--primary)' }}>
          <h3>My Profile (User)</h3>
          <form onSubmit={updateProfile} style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'flex-end' }}>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <label><small><strong>Full Name</strong></small></label>
              <input type="text" value={profileData.name} onChange={(e) => setProfileData({...profileData, name: e.target.value})} style={{ margin: 0 }} />
            </div>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <label><small><strong>Mobile Number</strong></small></label>
              <input type="text" value={profileData.phone} onChange={(e) => setProfileData({...profileData, phone: e.target.value})} style={{ margin: 0 }} />
            </div>
            <button type="submit" className="btn-success">Update Profile</button>
          </form>
        </div>

        {/* REQUEST FORM CARD */}
        <div className="card" style={{ position: 'relative' }}>
          <button 
            onClick={() => setShowSOSModal(true)}
            style={{ 
              position: 'absolute', top: '20px', right: '20px', backgroundColor: '#ff0000', color: 'white', 
              border: 'none', borderRadius: '50%', width: '60px', height: '60px', fontWeight: 'bold', 
              cursor: 'pointer', boxShadow: '0 0 15px rgba(255,0,0,0.5)', zIndex: 10
            }}
            className="sos-pulse"
          >
            SOS
          </button>

          <h2 style={{ textAlign: 'center', color: '#333' }}>Request Assistance</h2>
          <form onSubmit={sendRequest}>
            <label><strong>Problem Type</strong></label>
            <select value={isOther ? 'Other' : formData.problemType} onChange={handleProblemChange}>
              <option value="Petrol">Out of Petrol</option>
              <option value="Towing">Towing Service</option>
              <option value="Break">Brakes / Mechanical</option>
              <option value="Engine">Engine Issue</option>
              <option value="Flat Tire">Flat Tire</option>
              <option value="Oil Leak">Oil Leak</option>
              <option value="Battery Dead">Battery Dead</option>
              <option value="Key Lock">Key Lock</option>
              <option value="Accident">Accident Assistance</option>
              <option value="Other">Other</option>
            </select>

            {isOther && (
              <input type="text" placeholder="Describe your problem..." value={otherProblem} onChange={(e) => setOtherProblem(e.target.value)} required />
            )}

            <label style={{marginTop: '15px', display: 'block'}}><strong>Vehicle Details</strong></label>
            <input type="text" placeholder="e.g. Swift, Activa, etc" value={formData.vehicleType} onChange={(e) => setFormData({...formData, vehicleType: e.target.value})} required />

            <label><strong>Current Location</strong></label>
            <div style={{ display: 'flex', gap: '10px' }}>
              <input type="text" placeholder="Address..." value={formData.location} onChange={(e) => setFormData({...formData, location: e.target.value})} required style={{ flex: 1 }} />
              <button type="button" onClick={handleLocateMe} className="btn-primary" style={{ width: 'auto', padding: '0 15px' }} disabled={loadingLocation}>
                {loadingLocation ? '...' : '📍 Locate Me'}
              </button>
            </div>

            <div style={{ height: '200px', width: '100%', marginTop: '15px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #ddd' }}>
              <MapContainer center={[formData.lat, formData.lng]} zoom={15} style={{ height: '100%', width: '100%' }}>
                <ChangeView center={[formData.lat, formData.lng]} />
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker position={[formData.lat, formData.lng]} />
              </MapContainer>
            </div>

            <label style={{marginTop: '15px', display: 'block'}}><strong>Contact Number</strong></label>
            <input type="text" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} required />

            <button type="submit" className="btn-primary" style={{width: '100%', marginTop: '20px', padding: '12px'}}>Send Help Request</button>
          </form>
        </div>

        {/* SOS MODAL */}
        {showSOSModal && (
          <div className="modal-overlay" onClick={() => setShowSOSModal(false)}>
            <div className="modal-content card" onClick={(e) => e.stopPropagation()} style={{ borderTop: '10px solid red' }}>
              <h2 style={{ color: 'red', textAlign: 'center' }}>EMERGENCY SOS</h2>
              <p style={{ textAlign: 'center' }}>Contact emergency services below:</p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginTop: '20px' }}>
                <a href="tel:112" className="sos-link"><button className="btn-danger" style={{ width: '100%' }}>National (112)</button></a>
                <a href="tel:100" className="sos-link"><button className="btn-danger" style={{ width: '100%' }}>Police (100)</button></a>
                <a href="tel:108" className="sos-link"><button className="btn-danger" style={{ width: '100%' }}>Ambulance (108)</button></a>
                <a href="tel:101" className="sos-link"><button className="btn-danger" style={{ width: '100%' }}>Fire (101)</button></a>
                <a href="tel:1091" className="sos-link" style={{ gridColumn: 'span 2' }}><button className="btn-danger" style={{ width: '100%' }}>Women Helpline (1091)</button></a>
              </div>
              <div style={{ marginTop: '25px', textAlign: 'center' }}>
                <button className="btn-outline-gray" onClick={() => setShowSOSModal(false)}>Close</button>
              </div>
            </div>
          </div>
        )}

        {/* HISTORY TABLE - SORTED: NEWEST FIRST */}
        <div className="card" style={{ marginTop: '30px' }}>
          <h3>My Service History</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #eee', textAlign: 'left' }}>
                <th style={{ padding: '10px' }}>Problem</th><th style={{ padding: '10px' }}>Vehicle</th><th style={{ padding: '10px' }}>Status</th><th style={{ padding: '10px' }}>Date</th><th style={{ padding: '10px' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {history && history.length > 0 ? (
                [...history].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((h) => (
                  <tr key={h._id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '10px' }}>{h.problemType}</td>
                    <td style={{ padding: '10px' }}>{h.vehicleType}</td>
                    {/* 👇 ONLY THIS LINE WAS UPDATED TO ADD THE ACCEPTED BLUE COLOR 👇 */}
                    <td><span style={{ color: h.status === 'Completed' ? 'green' : h.status === 'Pending' ? 'orange' : h.status === 'Accepted' ? '#007bff' : 'red', fontWeight: 'bold' }}>{h.status}</span></td>
                    <td>{new Date(h.createdAt).toLocaleDateString('en-IN')}</td>
                    <td style={{ display: 'flex', gap: '5px' }}>
                      {h.status === 'Pending' && <button className="btn-danger" onClick={() => cancelRequest(h._id)}>Cancel</button>}
                      {(h.status === 'Accepted' || h.status === 'Completed') && <button className="btn-outline-gray" onClick={() => setSelectedMechanic(h.mechanicId)}>View Mechanic</button>}
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="5" style={{textAlign: 'center', padding: '20px'}}>No history yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {/* MECHANIC MODAL */}
        {selectedMechanic && (
          <div className="modal-overlay" onClick={() => setSelectedMechanic(null)}>
            <div className="modal-content card" onClick={(e) => e.stopPropagation()}>
              <h3>Mechanic Information</h3>
              <p><strong>Name:</strong> {selectedMechanic.name}</p>
              <p><strong>Email:</strong> {selectedMechanic.email || 'N/A'}</p>
              <p><strong>Phone:</strong> {selectedMechanic.phone || 'N/A'}</p>
              {selectedMechanic.phone && <a href={`tel:${selectedMechanic.phone}`}><button className="btn-success" style={{ width: '100%' }}>📞 Call Mechanic Now</button></a>}
              <button className="btn-danger" onClick={() => setSelectedMechanic(null)} style={{ marginTop: '15px' }}>Close</button>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default UserDashboard;
